/* eslint-disable react/no-unstable-nested-components */
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

import Logo from "components/logo";
import { IconifyIcons } from "components/Iconify";

import useAnimatedNavToggler from "hooks/useAnimatedNavToggler";
import { DesktopNavLinks, Header, LogoutButton, MobileNavLinks, MobileNavLinksContainer, NavLink, NavLinks, NavToggle, SecondaryLink } from "components/misc";
import useAuth from "hooks/use-auth";

// -------------------------------------------------------------------

const collapseBreakPointCssMap = {
  sm: {
    mobileNavLinks: tw`sm:hidden`,
    desktopNavLinks: tw`sm:flex`,
    mobileNavLinksContainer: tw`sm:hidden`
  },
  md: {
    mobileNavLinks: tw`md:hidden`,
    desktopNavLinks: tw`md:flex`,
    mobileNavLinksContainer: tw`md:hidden`
  },
  lg: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`
  },
  xl: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`
  }
};

// -------------------------------------------------------------------


export default function LogoOnlyHeader({ className, collapseBreakpointClass = "lg" }) {
  const { isAuthenticated, logout } = useAuth();

  const NavBar = () => (
    <NavLinks key={1}>
      {isAuthenticated && (
        <LogoutButton onClick={() => {logout()}}>
          Logout
        </LogoutButton>
      )}
    </NavLinks>
  );

  const { showNavLinks, animation, toggleNavbar } = useAnimatedNavToggler();
  const collapseBreakpointCss = collapseBreakPointCssMap[collapseBreakpointClass];

  return (
    <Header className={className || "header-light"}>
      <DesktopNavLinks css={collapseBreakpointCss.desktopNavLinks}>
        <Logo />
        <NavBar />
      </DesktopNavLinks>

      <MobileNavLinksContainer css={collapseBreakpointCss.mobileNavLinksContainer}>
        <Logo />
      </MobileNavLinksContainer>
    </Header>
  );
};

